import React from "react";

import { Trans } from "react-i18next";
import { Navigate, useNavigate } from "react-router-dom";

import Typography from "@mui/material/Typography";

import { useWifiQrCode } from "../../lib/hooks/useQueryBoard";

import Title from "../../components/Title";
import Curve from "../../components/Animations/PageTransitions/Curve";
import BackButton from "../../components/BackButton";

import useIdleEffect from "../../bit/board/hooks/useIdleEffect";

const Wifi = React.memo(() => {
  const navigate = useNavigate();

  const wifiQrCode = useWifiQrCode();

  useIdleEffect(() => {
    navigate("/", { replace: true });
  }, 60000);

  if (!wifiQrCode) {
    return Navigate({ to: "/" });
  }

  return (
    <Curve>
      <div className="d-flex align-items-center flex-column h-100">
        <BackButton to="/" />
        <Title>
          <Typography variant="h1">
            <Trans i18nKey="wifi:title" />
          </Typography>
        </Title>
        <img width="80%" alt="Wi-Fi QR code" src={wifiQrCode} />
      </div>
    </Curve>
  );
});

export default Wifi;
